import events from './events'
import store from 'reducers'
import Actions from './Actions'
import { LoadingActions } from 'actions'

export default class WaitingRoomActions extends Actions{
    static get target(){
        return 'waitingRoom'
    }

    static fetch(){
        LoadingActions.append({waitingRoom: true})
        this.client.organizations.waitingRoom.fetch({organizationID: store.getState().config.organizationID}).then(({data})=>{
            this.set(data)
            LoadingActions.append({waitingRoom: false})
        })
    }
}


// WEBPACK FOOTER //
// ./actions/WaitingRoomActions.js